import { render, staticRenderFns } from "./RGBWWidget.vue?vue&type=template&id=5a5f64fe"
import script from "./RGBWWidget.vue?vue&type=script&lang=js"
export * from "./RGBWWidget.vue?vue&type=script&lang=js"
import style0 from "./RGBWWidget.vue?vue&type=style&index=0&id=5a5f64fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports